(ns frontend.components.inputs.radio
  (:require
   [frontend.components.inputs.footprint :refer [display-string editor viewer]]
   [frontend.utils :as fu]
   [frontend.utils]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [:value :attribute :class-name :placeholder :options
                :has-focus?
                :on-focus! :on-blur! :on-change!
                :on-key-down! :disabled? :base-multiplier]}
        args
        option-choices (or (and options (fn? options) (options args))
                           (and options (coll? options) options))
        edit-value (or (:temp-value @dom-atom) value)
        clear-state! (fn []
                       (swap! dom-atom dissoc :temp-value))]
    [:div.zap-form__light-grey__green__sand.form__text.form-group.mb-0
     (doall (for [option option-choices]
              ^{:key (str attribute "-" (:label option))}
              [:label.my-1
               (let [k (:key option)]
                 [:label.zap-inlined-radiobox-label.mr-4
                  [:input
                   (merge {:type        "radio"
                           :name        (str attribute)
                           :checked     (= edit-value k)
                           :class-name  (fu/cs (when has-focus? "focus") class-name)
                           :on-focus    on-focus!
                           :on-blur     (fn [e]
                                          (when on-blur!
                                            (on-blur! e edit-value clear-state!)))
                           :on-key-down on-key-down!
                           :on-change   (fn [e]
                                          (let [checked (-> e
                                                            .-target
                                                            .-checked)]
                                            (when checked
                                              (swap! dom-atom assoc :temp-value k)
                                              (when on-change!
                                                (on-change! e k))
                                              (when on-blur!
                                                (on-blur! e k clear-state!)))))}
                          (when disabled?
                            {:disabled (boolean disabled?)}))]
                  [:span.radiomark]
                  (:label option)
                 ])
              ]))]))



(defmethod editor :editor.type/radio
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Radio"
      :component-did-mount    (fn [args]
                                (let []
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :first-label))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/radio
  [args]
  (let [selected (:value args)
        options (:options args)]
    (when selected
      (some->> options
               (filter (fn [o] (= (:key o) selected)))
               (first)
               :label))))

(defmethod viewer :editor.type/radio
  [args]
  (r/create-class
   {:display-name   "radio/viewer"
    :reagent-render (fn [args]
                      (let [selected (:value args)
                            options (:options args)]
                        [:div.preview.preview-radio
                         (when selected
                           (let [label (->> options
                                            (filter (fn [o] (= (:key o) selected)))
                                            (first)
                                            (:label))]
                             [:a
                              {:key      selected
                               :href     "#"
                               :on-click (fn [e]
                                           (.preventDefault e))}
                              label]))]))}))
